import { Outlet, useNavigate, useLocation } from 'react-router'
import { useAtomValue } from 'jotai/index'

import * as state from '../../states'
import { LoadingPage } from '../../pages'
import { useAppInit } from '../../hooks'
import { useEffect } from 'react'

import { ToastContainer } from 'react-toastify'
import { MENU } from '../../constants'

export const IndexLayout = () => {
	const navigate = useNavigate()
	const location = useLocation()

	const fetchIsLoading = useAtomValue(state.fetchIsLoadingAtom)
	const isAuth = useAtomValue(state.isAuthAtom)

	//TODO: check the logic (profile is not consistent after logout here [from inner data-state!])
	const { error, profile: profileNew, warmUp } = useAppInit(true)
	//console.log('layout.indexLayout:: useAppInit:: ', {profileNew})

	useEffect(() => {
		if (isAuth === true && [MENU.login.url].includes(location.pathname)) {
			navigate('/')
		}
	}, [isAuth, navigate])

	return <>
		<div style={{ display: 'none' }}>App</div>

		{fetchIsLoading > 0 ? (<LoadingPage/>) : null}

		<ToastContainer/>
		<Outlet/>
	</>
}
